import EverTrue from 'app';
import BaseRouter from 'base/base-router';
import MyTeamController from 'apps/my-team/controllers/my-team-controller';

class MyTeamRouter extends BaseRouter {
  constructor() {
    super();
    this.routes = {
      'team/performance': 'myTeam',
      'team/performance/:report_key': 'myTeamReport',
    };
  }

  myTeam() {
    EverTrue.execute('setBrowserTitle', 'Team');
    this.currentView = new MyTeamController();
    return EverTrue.page.mount(this.currentView);
  }

  myTeamReport(report_key) {
    EverTrue.execute('setBrowserTitle', 'Team');
    this.currentView = new MyTeamController({ report: report_key });
    return EverTrue.page.mount(this.currentView);
  }
}

export default MyTeamRouter;
